import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // For navigation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Importing eye icons
import imag from '../StyledComponents/img/logo (11).png'; // Assuming image path

function ChangePassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false); // Initially set to false
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false); // For confirm password visibility

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible); // Toggle visibility for password field
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible); // Toggle visibility for confirm password field
    };

    return (
        <div className="change-main">
            <div className="log-in-inner">
                <div className="top">
                    <div className="top-inner">
                        <div className="logo">
                            <img src={imag} alt="Logo" className="logo-w" />
                        </div>
                    </div>
                </div>

                <div className="form">
                    <form action="">
                        <div className="logos" style={{height: '18.7vh'}}>
                            {/* <img src={imag} alt="Logo" className="logoss"/> */}
                        </div>
                        <h2>Change Password</h2>

                        <div className="form-group fullname">
                            <label htmlFor="newPassword">New Password</label>
                            <div className="password-input-container">
                                <div className="password-container">

                                    <input
                                        id="newPassword"
                                        type={passwordVisible ? "text" : "password"} // Use dynamic type
                                        placeholder=""
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                                        onClick={togglePasswordVisibility} // Toggle password visibility
                                        style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '40px' }} // Positioning the icon
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="form-group fullname">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <div className="password-input-container">
                                <div className="password-container">

                                    <input
                                        id="confirmPassword"
                                        type={confirmPasswordVisible ? "text" : "password"} // Use dynamic type for confirm password
                                        placeholder=""
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <FontAwesomeIcon
                                        icon={confirmPasswordVisible ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                                        onClick={toggleConfirmPasswordVisibility} // Toggle confirm password visibility
                                        style={{ cursor: 'pointer', position: 'absolute', right: '10px', top: '40px' }} // Positioning the icon
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="btn">
                            <Link to="">Submit</Link>
                        </div>
                    </form>
                </div>

                <div className="bottom">
                    <div className="bottom-inner">
                        <div className="text-content">
                            <div className="copy">copyright @ WhooshkaTips</div>
                            <div className="text">
                                This page is for 18+ only. Gamble Responsibly. Visit
                                <span> www.gamblinghelponline.org.vic.au</span> or call <br />
                                Gambling Help on
                                <span>1800 858 858</span>
                                The chances are you are about to lose
                            </div>
                            <div className="policy">
                                Privacy Policy | Terms & Conditions
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;
